// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609210432/js/" + chunkId + "." + {"44":"6557b68f","225":"0ef9bdbd","481":"2b5cbf40","486":"e3a4c26e","770":"6f24caf3"}[chunkId] + ".0.9731494191802779.chunk.js";
};